import { render } from "./Drivers.vue?vue&type=template&id=363522d2&scoped=true"
import script from "./Drivers.vue?vue&type=script&lang=js"
export * from "./Drivers.vue?vue&type=script&lang=js"

import "./Drivers.vue?vue&type=style&index=0&id=363522d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363522d2"]])

export default __exports__